export var Service;
(function (Service) {
    /**
     *  Keycloak Service
     */
    Service["KEYCLOAK"] = "keycloak";
})(Service || (Service = {}));
//# sourceMappingURL=service.js.map